import styled from 'styled-components';
import DatePicker from 'react-datepicker';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }
  h6 {
    color: #e9ecef;
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const InputDate = styled(DatePicker)`
  width: 400px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 4px;
  color: #dee2e6;
  background: #323a4e;
  padding: 15px 5px;
  padding-left: ${p => (p.icon ? '2.5rem' : '1.6rem')};
  margin: 5px 0;
`;

export const Label = styled.div`
  margin: 20px 0;
  p {
    margin-bottom: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
  }
`;

export const Inner = styled.div`
  display: flex;
  margin: 22px 0;
  width: 48%;
  flex-direction: column;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;

export const DropContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  && ul {
    margin-top: 12px;
    width: 100%;
    max-width: 300px;
    display: flex;
    justify-content: space-around;
  }

  && ul li {
    border: 1px solid #fff;
    width: 25%;
    display: flex;
    font-size: 14px;
    line-height: 14px;
    padding: 6px 0 8px 0;
    justify-content: center;
    align-items: center;
  }
`;

export const InputArea = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 22px 0;
`;

export const DS = styled(DatePicker)`
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #dee2e6;
    font-family: Sarabun, sans-serif;
    font-size: 14px;
  }
  :-ms-input-placeholder {
    color: #dee2e6;
    font-family: Sarabun, sans-serif;
    font-size: 14px;
  }
  display: flex;
  width: 100%;
  height: 50px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 4px;
  padding: 0 0 0 8px;
  color: #dee2e6;
  background: #323a4e;
`;

export const DateContainer = styled.div`
  display: flex;
  width: 48%;
  flex-direction: column;

  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
    display: block !important;
  }

  .react-datepicker__portal {
    && div {
      width: auto !important;
    }
  }

  .react-datepicker {
    width: auto !important;
  }

  &:nth-child(1) > div {
    width: 100%;
  }
`;

export const DateLabel = styled.strong`
  margin-bottom: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
`;
export const ErrorLabel = styled.span`
  color: red !important;
  margin-top: 12px;
`;
